import { render, staticRenderFns } from "./BusDynamics.vue?vue&type=template&id=6dd64515&scoped=true&"
import script from "./BusDynamics.vue?vue&type=script&lang=js&"
export * from "./BusDynamics.vue?vue&type=script&lang=js&"
import style0 from "./BusDynamics.vue?vue&type=style&index=0&id=6dd64515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd64515",
  null
  
)

export default component.exports